// 购物车
export default {
  state: {
    catListNumber: 0, //购物车里商品数量
  },

  mutations: {
    setCatListNumber(state, value) {
      state.catListNumber = value
    }
  },

  actions: {

  }

}


// WEBPACK FOOTER //
// ./src/store/modules/cat.js